export enum ErrorCode {
  AccessDenied = 'AccessDenied',
  StreetIsInvalid = 'StreetIsInvalid',
  AgreementStatusIsInvalid = 'AgreementStatusIsInvalid',
  EmailAlreadyExists = 'EmailAlreadyExists',
  EmailAndPhoneNumberAlreadyExists = 'EmailAndPhoneNumberAlreadyExists',
  PhoneNumberAlreadyExists = 'PhoneNumberAlreadyExists',
  PhoneNumberHasIncorrectLength = 'PhoneNumberHasIncorrectLength',
  PhoneNumberHasIncorrectCharacter = 'PhoneNumberHasIncorrectCharacter',
  ThatPrefixIsNotInDb = 'ThatPrefixIsNotInDb',
  TwoEventsOverlap = 'TwoEventsOverlap',
  TimesheetRecordOutsideAgreementDateRange = 'TimesheetRecordOutsideAgreementDateRange',
  WorkerLimitForFileTypeExceeded = 'WorkerLimitForFileTypeExceeded',
  FileAlreadyExists = 'FileAlreadyExists',
  TokenIsIncorrect = 'TokenIsIncorrect',
  ThereIsNoGeneratedFileOnWorkerAgreement = 'ThereIsNoGeneratedFileOnWorkerAgreement',
  VerificationCodeHasExpired = 'VerificationCodeHasExpired',
  VerificationCodeIsNotCorrect = 'VerificationCodeIsNotCorrect',
  YouAreNotAllowedToAcceptThisAgreement = 'YouAreNotAllowedToAcceptThisAgreement',
  YouAreNotAllowedToDoThis = 'YouAreNotAllowedToDoThis',
  VerificationAgreementCodeErrorMessage = 'VerificationAgreementCodeErrorMessage',
  Failure = 'Failure',
  SomethingWentWrong = 'SomethingWentWrong',
  NoPermission = 'NoPermission',
  TimespanCannotBeEqualZero = 'TimespanCannotBeEqualZero',
  DocumentIsNotPdf = 'DocumentIsNotPdf',
  CannotDeleteApprovedTimesheetRecord = 'CannotDeleteApprovedTimesheetRecord',
  ThereIsNoRequiredDataForAgreementGeneration = 'ThereIsNoRequiredDataForAgreementGeneration',
  OldPasswordIsIncorrect = 'OldPasswordIsIncorrect',
  UserAccountHasNotBeenConfirmedYet = 'UserAccountHasNotBeenConfirmedYet',
  UserAccountIsAlreadyConfirmed = 'UserAccountIsAlreadyConfirmed',
  MaxFileCountExceeded = 'MaxFileCountExceeded',
  EmailNotConfirmed = 'EmailNotConfirmed',
  EmailNotConfirmedExtraMessage = 'EmailNotConfirmedExtraMessage',
  WrongTab = 'WrongTab',
  SomebodyElseHaveAlreadyApproved = 'SomebodyElseHaveAlreadyApproved',
  TimesheetMustBeApprovedByExternalWorkerFirst = 'TimesheetMustBeApprovedByExternalWorkerFirst',
  TimesheetMustBeApprovedByEmployeeFirst = 'TimesheetMustBeApprovedByEmployeeFirst',
  NoPermissionToApprove = 'NoPermissionToApprove',
  YouCannotUnapproveTimesheetBecauseItIsAlreadySettled = 'YouCannotUnapproveTimesheetBecauseItIsAlreadySettled',
  YouCannotModifyTimesheetBecauseItIsAlreadySettled = 'YouCannotModifyTimesheetBecauseItIsAlreadySettled',
  ActivationTokenIsInvalid = 'ActivationTokenIsInvalid',
  UserIsAlreadyActivated = 'UserIsAlreadyActivated',
  BankAccountOwnerTheSameAsUser = 'BankAccountOwnerTheSameAsUser',
  ChooseWorkMode = 'ChooseWorkMode',
  WorkerMustHaveRegisteredAddress = 'WorkerMustHaveRegisteredAddress',
  UserDoesNotHaveWorkerProfile = 'UserDoesNotHaveWorkerProfile',
  DelegationInvoicesReachedMaximumCount = 'DelegationInvoicesReachedMaximumCount',
  CannotPreviewFile = 'CannotPreviewFile',
  CouldNotAcceptAbsence = 'CouldNotAcceptAbsence',
  PresetDoesNotExists = 'PresetDoesNotExists',
  ThereIsNoWorkingTimeGroupOnAgreement = 'ThereIsNoWorkingTimeGroupOnAgreement',
  QrCodeExpired = "QrCodeExpired",
  QrCodeInvalid = "QrCodeInvalid",
  NoAgreementToLogWork = "NoAgreementToLogWork",
  MandateTemporaryAgreementMustHaveDateTo = "MandateTemporaryAgreementMustHaveDateTo",
  WorkerFormIsInvalid = "WorkerFormIsInvalid",
  HrNumberAlreadyExists = "HrNumberAlreadyExists",
  AnnexPreviewGenerationError = "AnnexPreviewGenerationError",
  ApproveIsNotNecessary = 'ApproveIsNotNecessary',
  DelegationSettlementDetailsExists = 'DelegationSettlementDetailsExists',
  FoundConflictedAnnexes = 'FoundConflictedAnnexes',
  UserAlreadySigned = 'UserAlreadySigned',
  AnnexWithoutChanges = 'AnnexWithoutChanges',
  AnnexDataChangedByAnotherUser = 'AnnexDataChangedByAnotherUser',
  AnnexMustContainAtLeastOneChange = 'AnnexMustContainAtLeastOneChange',
  AnnexConclusionDateBeforeAgreementConclusionDate = 'AnnexConclusionDateBeforeAgreementConclusionDate',
  AnnexStartDateBeforeConclusionDate = 'AnnexStartDateBeforeConclusionDate',
  AnnexConclusionDateInPast = 'AnnexConclusionDateInPast',
  AnnexEndDateBeforeStartDate = 'AnnexEndDateBeforeStartDate',
  AnnexChronologyConflictJobTitle = 'AnnexChronologyConflictJobTitle',
  AnnexChronologyConflictWage = 'AnnexChronologyConflictWage',
  AnnexChronologyConflictTemporaryWorkplace = 'AnnexChronologyConflictTemporaryWorkplace',
  AnnexChronologyConflictSupervisor = 'AnnexChronologyConflictSupervisor',
  AnnexChangesWagesError = 'AnnexChangesWagesError',
  AnnexChangesJobTitleError = 'AnnexChangesJobTitleError',
  AnnexSignatureConfigurationNotExist = 'AnnexSignatureConfigurationNotExist',
  AnnexComponentConfigurationNotExist = 'AnnexComponentConfigurationNotExist',
  AnnexTemplateNotExist = 'AnnexTemplateNotExist',
  WorkerFormResidentialAddressIsEmpty = 'WorkerFormResidentialAddressIsEmpty',
  AnnexStartDateInPast = 'AnnexStartDateInPast',
  AnnexStartDateBeforeEmploymentDateFrom = 'AnnexStartDateBeforeEmploymentDateFrom',
  AnnexStartDateAfterEmploymentDateTo = 'AnnexStartDateAfterEmploymentDateTo',
  WorkerAgreementIsInTermination = 'WorkerAgreementIsInTermination'
}
